import MetaTag from "components/Common/Meta-tag"
import React, { useEffect } from "react"
import Breadcrumbs from "components/Common/Breadcrumb"
import { Container } from "reactstrap"
import UpdateForm from "./UpdateForm"
import { useDispatch, useSelector } from "react-redux"
import { useParams } from "react-router-dom/cjs/react-router-dom.min"
import { getInspectionDetails } from "store/actions"

function UpdateInspectionDocs() {
  const dispatch = useDispatch()
  const params = useParams()

  useEffect(() => {
    dispatch(getInspectionDetails(params.id))
  }, [params.id])

  const inspectionDetails = useSelector(
    state => state.Inspection.inspectionDetails
  )
  return (
    <div>
      <MetaTag title={"Update Inspect"} />

      <div className="page-content">
        <Breadcrumbs
          title="Dashboard / Inspection"
          breadcrumbItem="Update Inspect"
        />
        <Container fluid>
          <UpdateForm updateData={inspectionDetails} />
        </Container>
      </div>
    </div>
  )
}

export default UpdateInspectionDocs
